import { SourceMap } from '../types'
import { findSourceMapRecords } from './findSourceMapRecords'
import { SiblingCandidates } from './groupSuggestionsBySibling'

const resolveMappedSourceIds = (
  sourceMaps: SourceMap[],
  ownerId: string,
  siblingId: string,
  sourceEntity: string
): Set<string> => {
  const records = findSourceMapRecords(sourceMaps, ownerId, siblingId, sourceEntity)
  const sourceIds = new Set<string>()

  records.forEach(record => {
    const sourceId = record.identifiers.find(identifier => identifier.identifierType === 'source')?.value
    if (sourceId) sourceIds.add(sourceId)
  })

  return sourceIds
}

// Removes suggestion candidates for a sibling's Customer/Supplier side that are already linked
// (same source record), so the wizard never re-creates a duplicate of an existing link — but
// keeps the rest of the ranked candidates selectable, since a pair can now have several distinct
// Customer/Supplier records (one-to-many). Also exposes the already-linked source ids so the UI
// can show which records are already linked (resolved to names at render).
export const excludeAlreadyMapped = (
  candidatesBySibling: Map<string, SiblingCandidates>,
  ownerId: string,
  sourceMaps: SourceMap[]
): Map<string, SiblingCandidates> => {
  const result = new Map<string, SiblingCandidates>()

  candidatesBySibling.forEach((candidates, siblingId) => {
    const customer = resolveMappedSourceIds(sourceMaps, ownerId, siblingId, 'Customer')
    const supplier = resolveMappedSourceIds(sourceMaps, ownerId, siblingId, 'Supplier')

    result.set(siblingId, {
      customer: candidates.customer.filter(candidate => !customer.has(candidate.sourceId)),
      supplier: candidates.supplier.filter(candidate => !supplier.has(candidate.sourceId)),
      customerAlreadyMappedIds: Array.from(customer),
      supplierAlreadyMappedIds: Array.from(supplier)
    })
  })

  return result
}
